/* 馬超傳・第 5 章：冀城、鹵城（212 年）
 * 冀城（漢陽郡治）在西北，方城、南面一座城門；鹵城在東南，小城、西面一座城門。往南的山路通往漢中。
 * 冀城的糧道從東邊進城。 */
export const JI = { x: 2600, y: 1500, hw: 800, hh: 520 }, LU = { x: 6000, y: 3300, hw: 520, hh: 380 };
const T = 36;
export const JI_GATE = [JI.x, JI.y + JI.hh], LU_GATE = [LU.x - LU.hw, LU.y], CAMP = [2600, 3100], SOUTH = [3600, 4500], EAST = [7700, 1500];
const ring = (C: { x: number; y: number; hw: number; hh: number }, gate: string) => {
  const N = C.y - C.hh, S = C.y + C.hh, W = C.x - C.hw, E = C.x + C.hw, G = 130;
  if (gate === 's') return [[C.x, N, C.hw + T, T], [W, C.y, T, C.hh], [E, C.y, T, C.hh], [(W + C.x - G) / 2, S, (C.x - G - W) / 2 + T, T], [(C.x + G + E) / 2, S, (E - C.x - G) / 2 + T, T]];
  return [[C.x, N, C.hw + T, T], [C.x, S, C.hw + T, T], [E, C.y, T, C.hh], [W, (N + C.y - G) / 2, T, (C.y - G - N) / 2], [W, (S + C.y + G) / 2, T, (S - C.y - G) / 2]];
};
export default {
  id: 'machao_jicheng', name: '冀城', W: 8000, H: 4800, seed: 212,
  bases: [CAMP, [JI.x, JI.y]],
  walls: [...ring(JI, 's'), ...ring(LU, 'w')],
  roads: [
    { pts: [CAMP, JI_GATE, [JI.x, JI.y]], w: 140 },
    { pts: [EAST, [5200, 1700], [3900, 2300], [JI.x + 300, JI_GATE[1] + 200], JI_GATE], w: 130 },
    { pts: [CAMP, [4200, 3300], LU_GATE, [LU.x, LU.y]], w: 130 },
    { pts: [CAMP, [3200, 3800], SOUTH], w: 120 },
  ],
  rocks: [[5200, 600, 460, 200], [1000, 3800, 420, 200], [6900, 4300, 400, 180], [800, 900, 360, 170], [4600, 4300, 380, 170]],
  woods: 0.35,
  sight: 0.8,
  clearings: [[JI.x, JI.y, 900], [LU.x, LU.y, 650], [CAMP[0], CAMP[1], 500], [JI_GATE[0], JI_GATE[1] + 400, 500], [LU_GATE[0] - 400, LU_GATE[1], 450], [SOUTH[0], SOUTH[1] - 200, 300]],
  villages: [{ x: JI.x, y: JI.y - 60, n: 9, r: 500 }, { x: LU.x + 60, y: LU.y, n: 5, r: 280 }],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 7, r: 420, chief: true, col: '#5a6a3a', flag: '馬' }],
  fields: [[4200, 2600, 520, 240], [1400, 2600, 420, 220, '#86803f']],
};
